import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  filter(event) {
    event.preventDefault()
    const selectedId = event.currentTarget.dataset.subcategoryId

    // Select all category containers
    const categories = document.querySelectorAll("[data-subcategory-filter-id]")

    categories.forEach(category => {
      if (category.dataset.subcategoryFilterId === selectedId) {
        category.style.display = ""  // show
      } else {
        category.style.display = "none" // hide
      }
    })

    this.updateActiveButton(event.currentTarget)
  }

  showAll(event) {
    event.preventDefault()
    const categories = document.querySelectorAll("[data-subcategory-filter-id]")
    categories.forEach(category => (category.style.display = ""))

    this.updateActiveButton(event.currentTarget)
  }

  updateActiveButton(activeButton) {
    // Remove active from all buttons
    const buttons = document.querySelectorAll(".subcategory-btn")
    buttons.forEach(btn => {
      btn.classList.remove("subcategory-active")
      btn.classList.add("subcategory-inactive")
    })

    // Add active to clicked button
    activeButton.classList.add("subcategory-active")
    activeButton.classList.remove("subcategory-inactive")
  }
}
